import { SITE, PHOTOS } from "../data/content";
import PageHero from "../components/PageHero";
import LegalSections from "../components/LegalSections";

const SECTIONS = [
  {
    h: "Our commitment",
    p: ["We want everyone to be able to plan a trip to Elk Creek. This website aims to meet the Web Content Accessibility Guidelines (WCAG) 2.2 at Level AA."],
  },
  {
    h: "What we've done",
    p: [
      "Keyboard navigation with a skip-to-content link and visible focus outlines, labelled form fields with clear error messages, text alternatives for photos, readable color contrast, a layout that works on phones and when zoomed, and reduced animation for visitors who prefer less motion.",
    ],
  },
  {
    h: "Known limitations",
    p: ["The optional Google Map and pages on Facebook, Instagram or a booking provider are run by third parties, and we can't fully control how accessible they are. Directions and contact details are always available as text on our Contact and FAQ pages."],
  },
  {
    h: "Need help or found a problem?",
    p: [`If anything on this site is hard to use, call us at ${SITE.phoneDisplay} or email ${SITE.email}. We'll help you get the information or booking you need, and we'll work to fix the issue.`],
  },
];

export default function Accessibility() {
  return (
    <main data-testid="accessibility-page">
      <PageHero image={PHOTOS.lakeWake} eyebrow="Accessibility" title="Accessibility Statement" subtitle="Our website should work for every guest." />
      <LegalSections sections={SECTIONS} effective="Last reviewed June 2026" />
    </main>
  );
}
